import { useState, FC, useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Button, Table, Tag, Icon } from 'mk-pc'
import { CommonStatus } from '@mk/core'
import { queryAppList } from '../service'
import '../styles/application.scss'

/**
 * 应用管理
 */
export const Application = () => {
  const [editVisible, setEditVisible] = useState(false)
  const [apps, setApps] = useState([] as any)

  useEffect(() => {
    fetchData()
  }, [])

  /**
   * 获取应用列表
   */
  const fetchData = async () => {
    const list = await queryAppList({})
    setApps(list)
  }

  return (
    <section className="os-application">
      <div className="os-application__search">
        <div className="form"></div>
        {/* <Button type="primary" onClick={() => setEditVisible(true)}>
          创建应用
        </Button> */}
      </div>
      <div className='os-application__list'>
        <Table dataSource={apps} scroll={{ x: 'max-content' }} pagination={false}>
          <Table.Column title="应用编码" dataIndex="code" key="code" width={140} />
          <Table.Column title="应用名称" dataIndex="name" key="name" width={140} />
          <Table.Column title="应用路径" dataIndex="url" key="url" width={300} />
          <Table.Column title="基础路由" dataIndex="baseRoute" key="baseRoute" width={150} />
          <Table.Column
            title="类型"
            dataIndex="isMain"
            key="isMain"
            width={120}
            render={(_: any, record: any) => {
              return record.isMain ? <Tag color="#A51F24">主应用</Tag> : <Tag>子应用</Tag>
            }}
          />
          <Table.Column title="排序" dataIndex="order" key="order" width={100} />
          <Table.Column
            title="状态"
            dataIndex="status"
            key="status"
            width={100}
            render={(_: any, record: any) => <CommonStatus status={record.status} />}
          />
          {/* <Table.Column
            title="操作"
            key="action"
            align="center"
            fixed="right"
            className="table-operatebtn"
            width={160}
            render={(_: any, record: any) => (
              <>
                <Button type="link">
                  <Icon name="icon-edit" />编辑
                </Button>
                <Button type="link">
                  <Icon name="icon-ashbin" /> 删除
                </Button>
              </>
            )}
          /> */}
        </Table>
      </div>
    </section>
  )
}
